import commasep from './commasep'

export default function (x, decimals) {
  return `$${commasep(x, decimals)}`
}
